import React, { useState, useEffect } from "react";
import { Typography, Box, Button } from "@mui/material";
import Tabs from "../../common/Tabs/Tabs";
import CreatorElement from "../../common/CreatorElement/CreatorElement";
import PropTypes from "prop-types";
import styles from "./PopularCreators.module.css";
import { apiFetch, API_BASE } from "../../../utils/api";
import * as Sentry from "@sentry/react";

const tabOptions = ["All", "Athlete", "Artist", "Organisation", "Team", "Event", "Other"];

const PopularCreators = ({ className = "" }) => {
  const [visibleCreators, setVisibleCreators] = useState(4);
  const [selectedTab, setSelectedTab] = useState("All");
  const [creatorsData, setCreatorsData] = useState([]);

  useEffect(() => {
    const fetchCreators = async () => {
      try {
        const response = await apiFetch(`/api/creators/popular?category=${selectedTab}`, {}, false, true);
        console.log(response);
        setCreatorsData(response || []);
      } catch (error) {
        Sentry.captureException(error);
        console.error("Failed to fetch popular creators:", error);
      }
    };

    fetchCreators();
  }, [selectedTab]);

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
    setVisibleCreators(4);
  };

  const handleLoadMore = () => {
    setVisibleCreators((prev) => prev + 4);
  };

  return (
    <section className={[styles.popularCreatorsSection, className].join(" ")}>
      <Typography className={styles.popularCreatorsTitle} component="h1">
        Browse popular creators
      </Typography>
      <Tabs tabs={tabOptions} onTabChange={handleTabChange} />
      {creatorsData.length === 0 ? (
        <Box className={styles.noCreatorsBox}>
          <Typography className={styles.noCreatorsText}>
            No creators in this category.
          </Typography>
        </Box>
      ) : (
        <>
          <Box className={styles.creatorsGrid}>
            {creatorsData.slice(0, visibleCreators).map((creator) => (
              <CreatorElement
                key={creator.id}
                image={`${API_BASE}${creator.image}`}
                picIcon={`${API_BASE}${creator.picIcon}`}
                title={creator.title}
                tag={creator.tag}
                nrLikes={creator.nrLikes}
                isUserLiked={creator.likedByUser}
                nrMoments={creator.nrMoments}
                descriptor={creator.link}
              />
            ))}
          </Box>
          {visibleCreators < creatorsData.length && (
            <Button className={styles.loadMoreButton} onClick={handleLoadMore}>
              Load More
            </Button>
          )}
        </>
      )}
    </section>
  );
};

PopularCreators.propTypes = {
  className: PropTypes.string,
};

export default PopularCreators;
